import React from "react";
import styled from "styled-components";
import {DateTimeFormatter, ZonedDateTime} from "js-joda";
import {Tooltip} from "antd";
import {months} from "../../../util/timeDescription";
import {baseFontSize, subduedTextColour} from "../../../style/styleConsts";
import {
    contentMapping, getProximityDaysAwayFromPairOfEarnings, getProximityDaysFromToday
} from "../../contribute/earnings/earnings";

const imageStyle = {
    width: 12,
    height: 12,
    marginRight: 5,
    marginTop: 1
};

const describeDateAndTimeOfEarnings = (date, time) => `Date: ${date} Time: ${time}`;

export function EarningsProximity({earnings}) {
    const closestEarnings = getProximityDaysAwayFromPairOfEarnings((earnings));
    return closestEarnings !== null ?
            <DateProximity earnings={closestEarnings} /> : null;
}

export function StockPageEarnings(props) {
    return props.earnings ?
        getProximityDaysFromToday(props.earnings) !== null ?
            <DateProximity earnings={getProximityDaysFromToday(props.earnings)}/>
            : <EarningsDate earnings={props.earnings}/>
        : null;
}

function DateProximity(props) {
    const content = contentMapping[props.earnings.daysFromToday];
    return  <Tooltip title={describeDateAndTimeOfEarnings(props.earnings.date, props.earnings.rawTime)} mouseLeaveDelay={0}>
               <div style={{color: content.colour, alignItems: "center", display: "flex"}}>
                           <img src={content.image} style={imageStyle}/>
                           <div style={{fontSize: baseFontSize}}>{content.text}</div>
                       </div>
            </Tooltip>;
}

const DateContainer = styled.div`
    color: ${subduedTextColour};
    font-size: 14px;
`;

function EarningsDate (props) {
    if (!props.earnings.instant) {
        return null;
    }

    const localDate = ZonedDateTime.parse(props.earnings.instant);
    return <Tooltip title={describeDateAndTimeOfEarnings(props.earnings.date, props.earnings.rawTime)}
                    mouseLeaveDelay={0}>
        <DateContainer>
            {localDate.format(DateTimeFormatter.ofPattern('dd ')) + months[localDate.monthValue() - 1] + " " + localDate.year()}
        </DateContainer>
    </Tooltip>;
}

